import { Link } from 'react-router-dom';

export default function Services() {
  return (
    <section id="services" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="mb-16">
          <p className="text-[#0EA5E9] text-sm font-medium mb-2">Services</p>
          <h2 className="text-4xl font-extrabold text-[#1A2332] leading-tight">
            Zenwestの<br />3つの柱
          </h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          {/* 記帳代行カード */}
          <div className="bg-gradient-to-br from-[#F0F9FF] to-[#E0F2FE] rounded-3xl p-10 hover:shadow-xl transition-all duration-300">
            <div className="w-16 h-16 flex items-center justify-center bg-[#1A2332] rounded-2xl mb-6">
              <i className="ri-file-list-3-line text-3xl text-white"></i>
            </div>
            
            <h3 className="text-2xl font-bold text-[#1A2332] mb-4">
              記帳代行「丸投げプラン」
            </h3>
            
            <p className="text-base text-gray-600 leading-relaxed mb-8">
              領収書をそのまま渡すだけでOK。忙しい経営者のための完全自動化支援。年商1,000万円まで、月間仕訳数100件までなら月額8,800円で対応可。
            </p>

            <div className="space-y-3 mb-8">
              <div className="flex items-center gap-3">
                <div className="w-6 h-6 flex items-center justify-center bg-[#0EA5E9] rounded-full">
                  <i className="ri-check-line text-white text-sm"></i>
                </div>
                <span className="text-gray-700">領収書の整理・仕訳入力</span>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-6 h-6 flex items-center justify-center bg-[#0EA5E9] rounded-full">
                  <i className="ri-check-line text-white text-sm"></i>
                </div>
                <span className="text-gray-700">月次試算表作成</span>
              </div>
            </div>

            <div className="pt-6 border-t border-[#0EA5E9]/20 flex items-end justify-between">
              <p className="text-4xl font-extrabold text-[#0EA5E9]">月額 ¥8,800~<span className="text-lg font-medium text-gray-500 ml-1">（税込）</span></p>
              <Link
                to="/pricing#bookkeeping-pricing"
                className="text-[#0EA5E9] text-sm font-semibold flex items-center gap-1 hover:gap-2.5 transition-all duration-300 cursor-pointer whitespace-nowrap shrink-0"
              >
                <span>料金詳細</span>
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </div>

          {/* IT導入支援カード */}
          <div className="bg-gradient-to-br from-[#E8EEF7] to-[#F0F4FA] rounded-3xl p-10 hover:shadow-xl transition-all duration-300">
            <div className="w-16 h-16 flex items-center justify-center bg-[#1A2332] rounded-2xl mb-6">
              <i className="ri-cloud-line text-3xl text-white"></i>
            </div>
            
            <h3 className="text-2xl font-bold text-[#1A2332] mb-4">
              IT導入・運用支援
            </h3>
            
            <p className="text-base text-gray-600 leading-relaxed mb-8">
              会計システム（弥生会計・freeeなど）の検討から初期設定、運用指導まで。クラウド会計で経理をラクに。
            </p>

            <div className="space-y-3 mb-8">
              <div className="flex items-center gap-3">
                <div className="w-6 h-6 flex items-center justify-center bg-[#1A2332] rounded-full">
                  <i className="ri-check-line text-white text-sm"></i>
                </div>
                <span className="text-gray-700">クラウド会計操作サポート</span>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-6 h-6 flex items-center justify-center bg-[#1A2332] rounded-full">
                  <i className="ri-check-line text-white text-sm"></i>
                </div>
                <span className="text-gray-700 text-sm">導入検討からご相談に乗ります</span>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-6 h-6 flex items-center justify-center bg-[#1A2332] rounded-full">
                  <i className="ri-check-line text-white text-sm"></i>
                </div>
                <span className="text-gray-700">初期設定・運用指導</span>
              </div>
            </div>

            <div className="pt-6 border-t border-[#1A2332]/20">
              <a href="#contact" onClick={(e) => { e.preventDefault(); document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' }); }} className="text-[#0EA5E9] font-semibold flex items-center gap-2 hover:gap-4 transition-all duration-300 cursor-pointer">
                <span>詳しくはお問合せください</span>
                <i className="ri-arrow-right-line"></i>
              </a>
            </div>
          </div>

          {/* ホームページ作成カード */}
          <div className="bg-gradient-to-br from-[#F0FDF4] to-[#DCFCE7] rounded-3xl p-10 hover:shadow-xl transition-all duration-300">
            <div className="w-16 h-16 flex items-center justify-center bg-[#1A2332] rounded-2xl mb-6">
              <i className="ri-global-line text-3xl text-white"></i>
            </div>
            
            <h3 className="text-2xl font-bold text-[#1A2332] mb-4">
              ホームページ作成
            </h3>
            
            <p className="text-base text-gray-600 leading-relaxed mb-8">
              インスタだけじゃ不安なオーナーへ。集客に強いホームページを制作し、公開後のメンテナンス・SEO対策まで一貫サポート。
            </p>

            <div className="space-y-3 mb-8">
              <div className="flex items-center gap-3">
                <div className="w-6 h-6 flex items-center justify-center bg-emerald-500 rounded-full">
                  <i className="ri-check-line text-white text-sm"></i>
                </div>
                <span className="text-gray-700">1ページ〜フルサイトまで対応</span>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-6 h-6 flex items-center justify-center bg-emerald-500 rounded-full">
                  <i className="ri-check-line text-white text-sm"></i>
                </div>
                <span className="text-gray-700">公開後の保守・更新サポート</span>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-6 h-6 flex items-center justify-center bg-emerald-500 rounded-full">
                  <i className="ri-check-line text-white text-sm"></i>
                </div>
                <span className="text-gray-700">SEO対策・集客強化プランあり</span>
              </div>
            </div>

            <div className="pt-6 border-t border-emerald-500/20 flex items-end justify-between">
              <div className="flex items-end gap-1">
                <p className="text-3xl font-extrabold text-emerald-600">¥11,000~</p>
                <span className="text-sm font-medium text-gray-500 mb-1">（税込）</span>
              </div>
              <Link
                to="/pricing#web-pricing"
                className="text-emerald-600 text-sm font-semibold flex items-center gap-1 hover:gap-2.5 transition-all duration-300 cursor-pointer whitespace-nowrap shrink-0"
              >
                <span>料金詳細</span>
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}